"use client";
import React, { useEffect } from "react";

function ScrollToTop() {
  useEffect(() => {
    window.scrollTo({
      behavior: "smooth",
      left: 0,
      top: 0,
    });
  }, []);
  return null;
}

export default ScrollToTop;
